import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_PROCESSES = "/infrastructure/processes/overview";
export const REDIRECT_TO_PROCESS_DETAIL = "/infrastructure/processes/detail";

export const finOpsPages = {
  id: "FinOps",
  label: "FinOps",
  icon: "auditbeatApp",
  items: [
    {
      label: "DBA Dashboard",
      path: "/dashboards/dba",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Host_Dashboards,
        role: Roles.Read,
      },
    },
    // {
    //   label: "Process",
    //   path: "/finops/process/overview",
    //   requireClientSelection: true,
    //   permissions: {
    //     subject: Subjects.Host_Dashboards,
    //     role: Roles.Read,
    //   },
    //   topNavLinks: [
    //     {
    //       label: "Overview",
    //       path: "/finops/process/overview",
    //       requireClientSelection: true,
    //     },
    //     {
    //       label: "Details",
    //       path: "/finops/process/detail",
    //       requireClientSelection: true,
    //     },
    //   ],
    // },
  ],
};
